import script from "./ElementAnimationPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementAnimationPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementAnimationPanel.vue?vue&type=style&index=0&id=7a134147&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a134147"]])

export default __exports__